import React from 'react';
import PropTypes from 'prop-types';

import classes from './ChatPopupOptions.module.scss';
import { IconButton } from 'modules/ui';
import { Colors } from 'modules/theme';

function ChatPopupOptions({ onMaximizeClick, onCloseClick }) {
  return (
    <div className={classes.popupIcons}>
      <IconButton
        iconName="maximize"
        onClick={onMaximizeClick}
        iconColor={Colors.grayishBlue}
        aria-label="Maximize chat window"
      />
      <IconButton
        iconName="close"
        onClick={onCloseClick}
        iconColor={Colors.grayishBlue}
        aria-label="Close chat window"
      />
    </div>
  );
}

ChatPopupOptions.propTypes = {
  onMaximizeClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default ChatPopupOptions;
